/**
 * Enum schemas for Textborne frontend
 * Mirrors backend src/schemas/enums/
 */

import { z } from 'zod';

// ============================================
// Content Rating
// ============================================

export const ContentRatingSchema = z.enum(['standard', 'mature', 'explicit']);
export type ContentRating = z.infer<typeof ContentRatingSchema>;

// ============================================
// Message Role
// ============================================

export const MessageRoleSchema = z.enum(['user', 'assistant', 'system']);
export type MessageRole = z.infer<typeof MessageRoleSchema>;

// ============================================
// World Status
// ============================================

export const WorldStatusSchema = z.enum(['active', 'archived', 'deleted']);
export type WorldStatus = z.infer<typeof WorldStatusSchema>;

// ============================================
// Arc/Chapter Status
// ============================================

export const ArcStatusSchema = z.enum(['active', 'completed']);
export type ArcStatus = z.infer<typeof ArcStatusSchema>;

export const ChapterStatusSchema = z.enum(['active', 'completed', 'pending_summary']);
export type ChapterStatus = z.infer<typeof ChapterStatusSchema>;

// ============================================
// Chapter Boundary Trigger
// ============================================

export const ChapterBoundaryTriggerSchema = z.enum([
  'location_change',
  'time_skip',
  'user_command',
  'message_limit',
]);
export type ChapterBoundaryTrigger = z.infer<typeof ChapterBoundaryTriggerSchema>;

// ============================================
// Reasoning Effort
// ============================================

export const ReasoningEffortSchema = z.enum(['minimal', 'low', 'medium', 'high', 'max']);
export type ReasoningEffort = z.infer<typeof ReasoningEffortSchema>;

// ============================================
// Scaffold Phase (for wizard progress)
// ============================================

export const ScaffoldPhaseSchema = z.enum([
  'starting',
  'phase1_parallel',
  'story_analyzing',
  'story_setting',
  'story_rules',
  'story_complete',
  'characters_scanning',
  'characters_iteration',
  'characters_complete',
  'phase2_enrichment',
  'enriching_character',
  'enrichment_complete',
  'finalizing',
  'complete',
  'error',
]);
export type ScaffoldPhase = z.infer<typeof ScaffoldPhaseSchema>;

// ============================================
// Trace Trigger Types
// ============================================

export const TraceTriggerTypeSchema = z.enum([
  'user_message',
  'opening_narrative',
  'curation',
  'sculpt',
  'world_creation',
]);
export type TraceTriggerType = z.infer<typeof TraceTriggerTypeSchema>;

// ============================================
// Phase Groups (for tracing)
// ============================================

export const PhaseGroupSchema = z.enum([
  'scaffolding',
  'preflight',
  'processing',
  'postprocessing',
]);
export type PhaseGroup = z.infer<typeof PhaseGroupSchema>;
